const data = {
	"width": 384,
	"height": 512,
	"body": "<path fill=\"currentColor\" d=\"M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400L0 512z\"/>"
};
exports.__esModule = true;
exports.default = data;
